import React, { useContext, useRef, useEffect } from "react";
import Swal from "sweetalert2";

import Footer from "../Templete/Footer";
import Header from "../Templete/Header";

import FormService from "../../Services/FormService";
import LoadingContext from "../../Store/loading-context";
import HttpError from "../../utill/HttpError";

const ContactUs = () => {
  const loadingCtx = useContext(LoadingContext);

  const nameRef = useRef();
  const emailRef = useRef();
  const mobileRef = useRef();
  const subjectRef = useRef();
  const messageRef = useRef();

  useEffect(() => {
    document.title = "Contact Us | Formax Pay";
  }, []);

  const submitHandler = async (e) => {
    e.preventDefault();

    const name = nameRef.current.value;
    const email = emailRef.current.value;
    const mobile = mobileRef.current.value;
    const subject = subjectRef.current.value;
    const message = messageRef.current.value;

    if (!name || !email || !mobile || !subject || !message) {
      Swal.fire("Oops!", "Please fill all required fields.", "error");
      return;
    }

    loadingCtx.startLoading();

    try {
      const responseData = await FormService.contactForm(
        name,
        email,
        mobile,
        subject,
        message,
      );

      const status = responseData.status;
      const message2 = responseData.message;

      if (status === "SUCCESS") {
        nameRef.current.value = "";
        emailRef.current.value = "";
        mobileRef.current.value = "";
        subjectRef.current.value = "";
        messageRef.current.value = "";
        Swal.fire("Success!", message2, "success");
      } else {
        Swal.fire("Opps!", message2, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  // Google Maps embed URL for Formax It Solutions Private Limited (Barasat, Kolkata)
  // Using the place name for accurate pin location
  const mapEmbedUrl =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3682.456789012345!2d88.4321!3d22.7123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f899f2d1613a0b%3A0x8b7693dab1225dc8!2sFormax%20It%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1712345678901!5m2!1sen!2sin";

  return (
    <>
      <Header />

      {/* Page Hero */}
      <section className="page-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p>
            We're here to help! Reach out for support, partnership, or any
            queries regarding recharges, payment, or bills.
          </p>
        </div>
      </section>

      <div className="container">
        <div className="contact-grid">
          {/* Left side: contact info cards */}
          <div className="contact-info">
            <div className="info-card">
              <i className="fas fa-map-marker-alt"></i>
              <h3>Visit Our Office</h3>
              <p>
                N0060, Mochpole, Near Junior School, Nabapally, Barasat, Kolkata
                - 700126, West Bengal, India
              </p>
            </div>
            <div className="info-card">
              <i className="fas fa-phone-alt"></i>
              <h3>Call / Support</h3>
              <p>
                <strong>Phone:</strong>{" "}
                <a href="tel:917890090500">+91 7890090500</a>
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:support@formaxpay.in">support@formaxpay.in</a>
              </p>
              <p>
                <strong>Business Hours:</strong> Mon-Sat, 9:00 AM – 8:00 PM
              </p>
            </div>
            <div className="info-card">
              <i className="fas fa-building"></i>
              <h3>Legal Information</h3>
              <p>
                <strong>Company:</strong> FORMAX IT SOLUTIONS PRIVATE LIMITED
              </p>
              <p>
                <strong>CIN:</strong> U72900WB2018PTC228240
              </p>
              <p>
                <strong>GSTIN:</strong> 19AADCF5125F1ZT
              </p>
            </div>
          </div>

          {/* Right side: contact form */}
          <div className="contact-form">
            <h2 style={{ marginBottom: "24px", fontSize: "1.8rem" }}>
              Send a Message
            </h2>
            <form onSubmit={submitHandler}>
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  ref={nameRef}
                  required
                  placeholder="John Doe"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  ref={emailRef}
                  required
                  placeholder="you@example.com"
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Mobile Number *</label>
                <input
                  type="tel"
                  id="phone"
                  ref={mobileRef}
                  required
                  placeholder="9876543210"
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <select id="subject" ref={subjectRef} required>
                  <option value="">-- Select Inquiry Type --</option>
                  <option value="Recharge Support">Recharge Support</option>
                  <option value="Payment Issue">Payment Issue</option>
                  <option value="Business Partnership">
                    Business Partnership
                  </option>
                  <option value="Feedback">Feedback / Suggestion</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  ref={messageRef}
                  rows="5"
                  required
                  placeholder="Describe your query in detail..."
                ></textarea>
              </div>
              <button type="submit" className="btn-submit">
                <i className="fas fa-paper-plane"></i> Send Message
              </button>
              <p
                style={{
                  fontSize: "0.75rem",
                  marginTop: "16px",
                  textAlign: "center",
                  color: "#64748b",
                }}
              >
                We'll get back to you within 24 hours.
              </p>
            </form>
          </div>
        </div>

        {/* Google Map Embed - Formax It Solutions Private Limited */}
        <div className="map-container">
          <iframe
            title="Formax It Solutions Private Limited - Office Location"
            src={mapEmbedUrl}
            width="100%"
            height="100%"
            style={{ border: 0, borderRadius: "32px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      <Footer />

      {/* CSS for contact page */}
      <style>{`
        .page-hero {
          background: linear-gradient(120deg, #eef2ff 0%, #f0f9ff 100%);
          padding: 50px 0 60px;
          text-align: center;
        }
        .page-hero h1 {
          font-size: 2.8rem;
          margin-bottom: 12px;
        }
        .page-hero p {
          color: #334155;
          max-width: 600px;
          margin: 0 auto;
        }
        .contact-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 48px;
          margin: 60px 0;
        }
        .contact-info {
          flex: 1;
          min-width: 260px;
        }
        .contact-form {
          flex: 1.5;
          min-width: 280px;
          background: white;
          padding: 32px;
          border-radius: 32px;
          box-shadow: var(--shadow-md, 0 20px 25px -12px rgba(0,0,0,0.08));
          border: 1px solid #eef2ff;
        }
        .info-card {
          background: white;
          border-radius: 28px;
          padding: 28px;
          margin-bottom: 24px;
          box-shadow: var(--shadow-sm, 0 10px 25px -5px rgba(0,0,0,0.05));
          border: 1px solid #eef2ff;
        }
        .info-card i {
          font-size: 2rem;
          color: var(--primary, #1e40af);
          margin-bottom: 16px;
        }
        .info-card h3 {
          margin-bottom: 12px;
          font-size: 1.3rem;
        }
        .info-card p, .info-card a {
          color: #475569;
          text-decoration: none;
          line-height: 1.5;
        }
        .form-group {
          margin-bottom: 20px;
        }
        .form-group label {
          font-weight: 600;
          display: block;
          margin-bottom: 8px;
        }
        .form-group input, .form-group select, .form-group textarea {
          width: 100%;
          padding: 14px 16px;
          border-radius: 48px;
          border: 1px solid #cbd5e1;
          font-size: 1rem;
          transition: 0.2s;
          font-family: 'Inter', sans-serif;
        }
        .form-group textarea {
          border-radius: 28px;
          resize: vertical;
        }
        .form-group input:focus, .form-group textarea:focus, .form-group select:focus {
          outline: none;
          border-color: var(--primary, #1e40af);
          box-shadow: 0 0 0 3px rgba(59,130,246,0.2);
        }
        .btn-submit {
          background: linear-gradient(95deg, #1e40af, #2563eb);
          color: white;
          padding: 14px 32px;
          border-radius: 48px;
          font-weight: 700;
          border: none;
          cursor: pointer;
          width: 100%;
          font-size: 1rem;
          transition: 0.2s;
        }
        .btn-submit:hover {
          background: linear-gradient(95deg, #1e3a8a, #1e40af);
          transform: translateY(-2px);
        }
        .map-container {
          width: 100%;
          height: 350px;
          border-radius: 32px;
          overflow: hidden;
          margin: 30px 0 20px;
          box-shadow: var(--shadow-sm, 0 10px 25px -5px rgba(0,0,0,0.05));
          border: 1px solid #eef2ff;
        }
        @media (max-width: 720px) {
          .page-hero h1 { font-size: 2rem; }
          .map-container { height: 250px; }
        }
      `}</style>
    </>
  );
};

export default ContactUs;
